<!--下单-->
<template>
    <div style="height:100%;background:#f8f8f8;padding:0.2rem 0 1rem 0 ">
        <!-- 下单 -->

        <van-form
                @submit="onSubmit"
        >
            <van-divider>考试信息</van-divider>
            <van-cell-group v-if="list.length>0">
                <van-field
                        :value="exame.extra_data.danwei+'('+exame.extra_data.datetitle+')'"
                        readonly
                        label="单位"
                        input-align="right"
                />
                <van-field
                        :value="(formData.currentIndex+1)+'/'+list.length"
                        readonly
                        label="当前/总人数"
                        input-align="right"
                />

                <van-field
                        :value="(user.name)+' ('+user.type+')'"
                        readonly
                        label="裁判信息"
                        input-align="right"
                />

            </van-cell-group>

            <van-divider>考生信息</van-divider>
            <van-cell-group v-if="list.length>0">
                <van-field
                        v-model="list[formData.currentIndex].name"
                        readonly
                        label="姓名"
                        input-align="right"
                />
                <van-field
                        v-model="list[formData.currentIndex].grade"
                        readonly
                        label="星级"
                        input-align="right"
                />

                <van-field
                        v-model="list[formData.currentIndex].num"
                        readonly
                        label="证件号"
                        input-align="right"
                />

            </van-cell-group>
            <van-divider>评分信息</van-divider>
            <van-cell-group v-if="list.length>0 && user.type=='考官'">

                <van-field
                        v-model="list[formData.currentIndex]['score_fanteng'+user.index]"
                        :rules="[{ required: true, message: '请输入分数' }]"
                        error-message-align="right"
                        label="翻腾"
                        input-align="right"
                        clearable
                        placeholder="请输入分数"
                />

                <van-field
                        v-model="list[formData.currentIndex]['score_zhuanti'+user.index]"
                        :rules="[{ required: true, message: '请输入分数' }]"
                        error-message-align="right"
                        label="转体"
                        input-align="right"
                        clearable
                        placeholder="请输入分数"
                />
                <van-field
                        v-model="list[formData.currentIndex]['score_tiaoyue'+user.index]"
                        :rules="[{ required: true, message: '请输入分数' }]"
                        error-message-align="right"
                        label="跳跃"
                        input-align="right"
                        clearable
                        placeholder="请输入分数"
                />
                <van-field
                        v-model="list[formData.currentIndex]['score_pingheng'+user.index]"
                        :rules="[{ required: true, message: '请输入分数' }]"
                        error-message-align="right"
                        label="平衡柔韧"
                        input-align="right"
                        clearable
                        placeholder="请输入分数"
                />
                <van-field
                        v-model="list[formData.currentIndex]['score_liliang'+user.index]"
                        :rules="[{ required: true, message: '请输入分数' }]"
                        error-message-align="right"
                        label="力量素质"
                        input-align="right"
                        clearable
                        placeholder="请输入分数"
                />
                <van-field
                        v-model="list[formData.currentIndex]['score_dongzuo'+user.index]"
                        :rules="[{ required: true, message: '请输入分数' }]"
                        error-message-align="right"
                        label="动作组合"
                        input-align="right"
                        clearable
                        placeholder="请输入分数"
                />


            </van-cell-group>


            <van-cell-group v-if="list.length>0 && user.type=='监督'">

                <van-field
                        v-model="list[formData.currentIndex]['score_fanteng1']"
                        label="翻腾1"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_fanteng2']"
                        label="翻腾2"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_fanteng3']"
                        label="翻腾3"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_fanteng4']"
                        label="翻腾4"
                        readonly
                        input-align="right"

                />


                <van-field
                        v-model="list[formData.currentIndex]['score_zhuanti1']"
                        label="转体1"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_zhuanti2']"
                        label="转体2"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_zhuanti3']"
                        label="转体3"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_zhuanti4']"
                        label="转体4"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_tiaoyue1']"
                        label="跳跃1"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_tiaoyue2']"
                        label="跳跃2"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_tiaoyue3']"
                        label="跳跃3"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_tiaoyue4']"
                        label="跳跃4"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_pingheng1']"
                        label="平衡柔韧1"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_pingheng2']"
                        label="平衡柔韧2"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_pingheng3']"
                        label="平衡柔韧3"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_pingheng4']"
                        label="平衡柔韧4"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_liliang1']"
                        label="力量素质1"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_liliang2']"
                        label="力量素质2"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_liliang3']"
                        label="力量素质3"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_liliang4']"
                        label="力量素质4"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_dongzuo1']"
                        label="动作组合1"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_dongzuo2']"
                        label="动作组合2"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_dongzuo3']"
                        label="动作组合3"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_dongzuo4']"
                        label="动作组合4"
                        readonly
                        input-align="right"

                />
                <van-field
                        v-model="list[formData.currentIndex]['score_total']"
                        label="总分"
                        readonly
                        input-align="right"

                />


            </van-cell-group>
            <div style="height: 1rem"></div>

            <div class="savebtn">
                <van-button
                        style="width: 3rem"
                        size="normal" round    native-type="button"  @click="pre">上一位</van-button>

                <van-button
                        v-if="user.type=='考官'"
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem ; margin: 0 10px"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."  >保存</van-button>

                <van-button
                        style="width: 3rem"
                        size="normal" round  native-type="button"    @click="nex">下一位</van-button>

            </div>
        </van-form>



        <van-dialog v-model="numShow" title="请输入您的身份证号" @confirm="numConfirm"  >
            <!--<p style="padding: 10px; text-align: center">此鞋型偏小，建议选大一码</p>-->
            <van-field v-model="userNum" label="身份证号" size="large" placeholder="请输入您的身份证号码" clearable />
        </van-dialog>

    </div>
</template>
<style scoped>

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }

    .shop-name {
        display: flex;
        justify-content: space-between;
        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 27px;
        margin-top: 0.4rem;
        padding: 0 0.3rem;
    }
    .shop-address {
        height: 13px;
        font-size: 9px;
        
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 13px;
        margin-top: 0.1rem;
        padding: .2rem .3rem .4rem;
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
    .delivery-times {
        margin-top: 0.2rem;
        padding: 0 0.3rem;
        display: flex;
        justify-content: space-between;
    }
    .business-shop-info {
        width: 6.81rem;
        height: 2.66rem;
        border-radius: 7px;
        margin-bottom: 0;
        display: flex;
        flex-flow: column;
        position: absolute;
        bottom: -0.4rem;
        left: 0;
        right: 0;
        margin: auto;
        background: #fff
        6.5rem center;
        background-size: 10px;
    }
    .check-header {
        width: 100%;
        height: 4.4rem;
        background: url("https://static.dierqudao.com/images/dinghuoxitong/bg-mine-index.png")
        no-repeat center;
        background-size: 100%;
        position: relative;
    }

</style>

<script>
    import { Field, Notify, Toast, Popup, Picker,Radio,RadioGroup,Dialog,ImagePreview } from "vant";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    export default {
        name: "ExameScoreDetail",
        components: {
            [Field.name]: Field,
            Notify,
            Dialog,
            Radio,
            RadioGroup,
            Popup,
            [ImagePreview.Component.name]: ImagePreview.Component,
            PicUploader,
            Toast,
            Picker
        },
        data: function() {
            return {
                validator,
                isSubmit:false,
                showGradePicker:false,
                numShow:false,
                exame_id: this.$route.query.exame_id,
                message: "",
                userNum:'',
                formData: {
                    needLoadingIndicator: true,
                    currentIndex:0,
                    exame_id:this.$route.query.exame_id,
                    name:'',
                    grade:'',
                    pic:[],
                },
                list:[],
                user:{
                    index:1
                },
                exame:{
                    extra_data:{

                    }
                },
                warnings: [],
                saveLoading:false,

            };
        },
        watch: {
        },

        filter: {},
        mounted() {
            document.title = "评分页";
            this.fetch();
        },
        destroyed() {},
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/kaojiexame/score2List', {
                    exame_id : that.exame_id,
                    num : sessionStorage.getItem('qcxjcpnum')
                }, (res) => {
                    that.list = res.data.list;
                    that.user = res.data.user;
                    that.exame = res.data.exame;
                }, (res) => {
                    if(res.code==409){
                        that.numShow = true;
                    }
                    Toast.fail(res.msg);
                })
            },

            numConfirm(){
                console.log('numConfirm');
                sessionStorage.setItem('qcxjcpnum',this.userNum);
                let that = this;
                this.fetch();
//                that.numShow = true;
            },
            pre(){
                if(this.formData.currentIndex ==0){
                    Toast.fail('已经是第一位了');
                }else{
                    this.formData.currentIndex--;
                }
            },
            nex(){
                if((this.formData.currentIndex+1) >= this.list.length){
                    Toast.fail('已经是最后一位了');
                }else{
                    this.formData.currentIndex++;
                }
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            onSubmit(){
                let that = this;
                that.saveLoading = true;
                that.$api.post('/api/kaojiexame/score2Save', {
                    row:that.list[that.formData.currentIndex],
                    user_type:that.user.type,
                    user_index:that.user.index
                }, (res) => {
                    that.saveLoading = false;
                    Toast.success('修改成功');
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },

        }
    };
</script>



// WEBPACK FOOTER //
// ExameScoreDetail.vue?565c608c